import React, { useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaFacebook,
  FaInstagram,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaWhatsapp,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { InfoContext } from "../providers/InfosContextProvider";

const Footer = () => {
  const { texts } = useContext(InfoContext);
  return (
    <footer className="footer-golden py-4">
      <Container>
        <Row className="d-flex justify-content-between align-items-center">
          <Col
            xs={12}
            md={4}
            className="mb-4 mb-md-0 text-center text-md-start"
          >
            <h5 className="footer-title">{texts.footer_contact.title}</h5>
            <div className="footer-contact-section">
              <p className="mb-2 footer-link-item">
                <FaPhone className="me-2" />
                <a
                  href={`tel:${texts.footer.tel2.replace(/\+/g, "00").replace(/\s/g, "")}`}
                >
                  {texts.footer.tel}
                </a>
              </p>
              <p className="mb-2 footer-link-item">
                <FaEnvelope className="me-2" />
                <span>{texts.footer.email}</span>
              </p>
              <div className="mt-3 mb-3">
                <Link to="/contact" className="btn btn-sell">
                  {texts.footer_contact.button}
                </Link>
              </div>
            </div>
          </Col>

          <Col
            xs={12}
            md="auto"
            className="d-flex flex-column align-items-center align-items-md-end justify-content-center"
          >
            <div className="d-flex mb-3">
              <a
                href={`${texts.footer.facebook}`}
                className="me-3"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook size={20} />
              </a>
              <a
                href={`${texts.footer.insta}`}
                className="me-3"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram size={20} />
              </a>
            </div>
            <p className="mb-0 footer-link-item">
              <FaMapMarkerAlt className="me-2" />
              <a
                href="https://www.google.com/maps/search/?api=1&query=Rua+Silva+Magalhães+14,+Tomar,+Portugal"
                target="_blank"
                rel="noopener noreferrer"
              >
                {texts.footer.address}
              </a>
            </p>
          </Col>
        </Row>

        <Row className="mt-4 mb-2">
          <Col className="d-flex justify-content-center flex-wrap gap-3">
            <Link
              to="/dispute-resolution"
              className="whistleblowing-link"
              style={{ fontSize: "0.8rem", opacity: 0.8 }}
            >
              {texts.footer_links?.disputeResolution}
            </Link>
            <a
              href="https://www.livroreclamacoes.pt"
              target="_blank"
              rel="noopener noreferrer"
              className="whistleblowing-link"
              style={{ fontSize: "0.8rem", opacity: 0.8 }}
            >
              {texts.footer_links?.complaintsBook}
            </a>
            <Link
              to="/terms-and-conditions"
              className="whistleblowing-link"
              style={{ fontSize: "0.8rem", opacity: 0.8 }}
            >
              {texts.footer_links?.termsAndConditions}
            </Link>
            <Link
              to="/cookies-policy"
              className="whistleblowing-link"
              style={{ fontSize: "0.8rem", opacity: 0.8 }}
            >
              {texts.footer_links?.cookiesPolicy}
            </Link>
          </Col>
        </Row>

        <Row className="pt-3 border-top mt-1">
          <Col className="text-center">
            <p className="mb-0">AMI 23473 • {`${texts.footer.copyright}`}</p>
          </Col>
        </Row>
      </Container>
      <a
        href={`https://wa.me/${texts.footer.tel.replace(/\+/g, "").replace(/\s/g, "")}?text=${encodeURIComponent("Olá, Casas do Nabão! ")}`}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <FaWhatsapp size={24} />
      </a>
    </footer>
  );
};

export default Footer;
